<template>
  <div class="filter-bar-container">
    <div class="filter-bar">
      <!-- 区域分析 -->
      <div class="filter-item" @click="onCityClick">
        <img class="prefix-icon" src="@/assets/image/icon_filterLocation.png" alt="loc" />
        <span class="label">{{ cityLabel }}</span>
        <img class="arrow-icon" src="@/assets/image/arrow_down_white.png" alt="arrow" />
      </div>

      <div class="divider"></div>

      <!-- 时间范围 -->
      <div class="filter-item" @click="onTimeClick">
        <img class="prefix-icon" src="@/assets/image/icon_filterTime.png" alt="time" />
        <span class="label">{{ timeLabel }}</span>
        <img class="arrow-icon" src="@/assets/image/arrow_down_white.png" alt="arrow" />
      </div>

      <div class="divider"></div>

      <!-- 更多 -->
      <div class="filter-item" @click="onMoreClick">
        <img class="prefix-icon" src="@/assets/complaint/ic_complain_filter.png" alt="more" />
        <div class="label-wrapper">
          <span class="label">更多</span>
          <span v-if="moreCount > 0" class="badge">{{ moreCount }}</span>
        </div>
        <img class="arrow-icon" src="@/assets/image/arrow_down_white.png" alt="arrow" />
      </div>
    </div>

    <!-- 城市筛选弹窗 -->
    <van-popup v-model="showCityPicker" round position="bottom">
      <div class="region-picker-header">
        <span>统计区域</span>
        <van-icon name="arrow-down" color="#999" size="18" @click="showCityPicker = false" />
      </div>
      <div class="region-picker-body">
        <!-- 左侧列 -->
        <div class="region-left-col" :class="{ 'full-width': !hasRightColumn }">
          <div v-for="item in allRegionIncludeSelf" :key="item.id" class="region-left-item" :class="{
            active: item.children && item.children.length && expandedLeftId === item.id,
            selected: activeId === item.id && (!item.children || !item.children.length)
          }" @click="onLeftItemClick(item)">
            <span>{{ item.text }}</span>
            <van-icon v-if="item.children && item.children.length" name="arrow" size="12" color="#999" />
            <van-icon v-else-if="activeId === item.id" name="success" size="16" color="#00bc71" />
          </div>
        </div>
        <!-- 右侧列 -->
        <div v-if="hasRightColumn" class="region-right-col">
          <div v-for="child in rightColumnList" :key="child.id" class="region-right-item"
            :class="{ active: activeId === child.id }" @click="onRightItemClick(child)">
            <span>{{ child.text }}</span>
            <van-icon v-if="activeId === child.id" name="success" size="16" color="#00bc71" />
          </div>
        </div>
      </div>
    </van-popup>

    <common-picker ref="timePicker" :typeList="typeListTime" :pickerDefaultIndex="pickerDefaultIndex" :cols="3"
      :isShowAbountButton="true" @getTypeValue="onTimeChange" @showRangTime="onShowCustomTime" />

    <rangTime ref="customTimePicker" @getCurrentTime="onCustomTimeChange" />

    <ChannelAndRuleFilterModal v-if="showMoreModal" :complainChannel="complainChannelList"
      :analysisRule="analysisRuleList" :initialChannel="selectedChannel" :initialRule="selectedRule"
      @confirm="onMoreConfirm" @close="showMoreModal = false" />
  </div>
</template>

<script>
import commonPicker from "@/components/base/commonPicker";
import { complaintTime } from "@/utils/configJson.js";
import rangTime from "@/components/rangTime1";
import APIS from "@/service/modules/complaintApis/modules/visualization.js";
import ChannelAndRuleFilterModal from './ChannelAndRuleFilterModal.vue';

export default {
  name: 'FilterBar',
  components: {
    commonPicker,
    rangTime,
    ChannelAndRuleFilterModal
  },
  props: {
    initialCity: { type: String, default: '云南省' },
    areaOne: { type: String, default: '' },
  },
  data() {
    const typeListTime = complaintTime();
    return {
      cityLabel: this.initialCity,
      timeLabel: '时间范围',

      selectedAreaId: this.areaOne,
      beginTime: '',
      endTime: '',
      selectedChannel: '',
      selectedRule: '',

      showMoreModal: false,
      showCityPicker: false,
      expandedLeftId: '',
      activeId: this.areaOne,

      typeListTime: typeListTime,
      pickerDefaultIndex: [typeListTime[0].length - 1, 0, 0],
      complainChannelList: [],
      analysisRuleList: []
    }
  },
  computed: {
    moreCount() {
      let count = 0;
      if (this.selectedChannel) count++;
      if (this.selectedRule !== '') count++;
      return count;
    },
    deptInfo() {
      return this.$store.state.complaint.deptInfo;
    },
    allRegionIncludeSelf() {
      return this.$store.state.complaint.allRegionIncludeSelf;
    },
    // 当前展开项的右侧列表
    rightColumnList() {
      if (!this.expandedLeftId) return [];
      const found = this.allRegionIncludeSelf.find(item => item.id === this.expandedLeftId);
      return found && found.children ? found.children : [];
    },
    // 是否有任何分支项，决定是否显示右侧列
    hasRightColumn() {
      return this.allRegionIncludeSelf.some(item => item.children && item.children.length > 0);
    }
  },
  watch: {
    areaOne(val) {
      if (val) this.activeId = val;
    }
  },
  created() {
    this.fetchFilterData();
  },
  mounted() { },
  methods: {
    // --- 接口请求 ---
    fetchFilterData() {
      APIS.getComplainChannel().then(res => {
        if (res.ret === 0) {
          // 接口返回 { data: { list: [{ code, name }] } }
          // Modal 组件需要 [{ value, label }] 格式
          const list = (res.data && res.data.list) || [];
          this.complainChannelList = list.map(item => ({ value: String(item.code), label: item.name }));
        }
      });
      APIS.getAnalysisRule().then(res => {
        if (res.ret === 0) this.analysisRuleList = res.data;
      });
      this.fetchCityData();
    },
    fetchCityData() {
      this.$store.dispatch("complaint/getAllRegionIncludeSelf").then(data => {
        const regionList = Array.isArray(data) ? data : (data ? [data] : []);
        if (!regionList.length) return;
        const hasInitialCityLabel = !!(this.initialCity && String(this.initialCity).trim());

        // 若外部已传 areaOne，优先回显该选中项
        const selected = regionList.find(item => String(item.id) === String(this.selectedAreaId));
        if (selected) {
          this.activeId = selected.id;
          // 首次展示优先使用 fullAddress（initialCity），避免被接口文案覆盖
          if (!hasInitialCityLabel) {
            this.cityLabel = selected.text || this.cityLabel;
          }
          this.syncExpandedLeft();
          return;
        }

        // 无初始值时，默认选中第一项并向外同步
        if (!this.selectedAreaId) {
          const first = regionList[0];
          this.selectedAreaId = first.id;
          this.activeId = first.id;
          if (!hasInitialCityLabel) {
            this.cityLabel = first.text;
          }
          this.emitChange();
        }
        this.syncExpandedLeft();
      });
    },

    // --- 事件处理 ---
    onCityClick() {
      this.syncExpandedLeft();
      this.showCityPicker = true;
    },
    onTimeClick() {
      this.$refs.timePicker && this.$refs.timePicker.showPicker();
    },
    onMoreClick() {
      this.showMoreModal = true;
    },

    // --- 左侧列点击 ---
    onLeftItemClick(item) {
      if (item.children && item.children.length > 0) {
        // 有子级：展开右侧列，高亮左侧
        this.expandedLeftId = item.id;
      } else {
        // 叶子节点（全部、省级）：直接选中并关闭
        this.showCityPicker = false;
        this.activeId = item.id;
        this.selectedAreaId = item.id;
        this.cityLabel = item.text;
        this.emitChange();
      }
    },

    // --- 右侧列点击 ---
    onRightItemClick(child) {
      this.showCityPicker = false;
      this.activeId = child.id;
      this.selectedAreaId = child.id;

      // "全部"或"市级"时显示父级名称
      if (child.text === '全部' || child.text === '市级') {
        const parent = this.allRegionIncludeSelf.find(item => item.id === this.expandedLeftId);
        this.cityLabel = parent ? parent.text : child.text;
      } else {
        this.cityLabel = child.text;
      }
      this.emitChange();
    },

    // --- 其他回调 ---
    onTimeChange(value) {
      if (value[1].key === "year") {
        this.timeLabel = value[0].value;
        this.beginTime = `${value[0].value}-01-01 00:00:00`;
        this.endTime = `${value[0].value}-12-31 23:59:59`;
      } else if (value[1].key === "quarter") {
        this.timeLabel = value[0].value + value[2].text;
        this.beginTime = `${value[0].value}-${value[2].value1} 00:00:00`;
        this.endTime = `${value[0].value}-${value[2].value2} 23:59:59`;
      } else if (value[1].key === "moutn") {
        const d = new Date(value[0].value, value[2].value1, 0);
        this.beginTime = `${value[0].value}-${value[2].value1}-01 00:00:00`;
        this.endTime = `${value[0].value}-${value[2].value1}-${d.getDate()} 23:59:59`;
        this.timeLabel = `...${value[2].value1}/${d.getDate()}`;
      }
      this.emitChange();
    },
    onShowCustomTime() {
      this.$refs.customTimePicker.showTime();
    },
    onCustomTimeChange(value) {
      if (value) {
        this.beginTime = value[0];
        this.endTime = value[1];
        const end = value[1].split(' ')[0].split('-');
        this.timeLabel = `...${end[1]}/${end[2]}`;
        this.emitChange();
      }
    },
    onMoreConfirm(data) {
      this.selectedChannel = data.channel;
      this.selectedRule = data.rule;
      this.emitChange();
    },

    emitChange() {
      this.$emit('change', {
        areaId: this.selectedAreaId,
        areaName: this.cityLabel,
        beginTime: this.beginTime,
        endTime: this.endTime,
        channel: this.selectedChannel,
        rule: this.selectedRule
      });
    },

    // 根据当前选中项同步展开状态
    syncExpandedLeft() {
      if (!this.activeId || !this.allRegionIncludeSelf.length) {
        this.expandedLeftId = '';
        return;
      }
      // 判断当前选中项是否属于某个分支的 children
      const parentItem = this.allRegionIncludeSelf.find(item =>
        item.children && item.children.length > 0 && item.children.some(c => c.id === this.activeId)
      );
      if (parentItem) {
        // 选中项是某个州市的子项，展开该州市
        this.expandedLeftId = parentItem.id;
      } else {
        // 选中项是叶子节点（全部/省级），不展开任何分支
        this.expandedLeftId = '';
      }
    }
  }
}
</script>

<style lang="less" scoped>
.filter-bar-container {
  position: fixed;
  bottom: 24px;
  left: 12px;
  right: 12px;
  z-index: 100;
}

.filter-bar {
  height: 48px;
  background: rgba(113, 113, 113, 0.95);
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  .filter-item {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 0 4px;

    .prefix-icon {
      width: 18px;
      height: 18px;
      object-fit: contain;
    }

    .label {
      font-size: 14px;
      color: #ffffff;
      max-width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .label-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }

    .badge {
      background: #ffffff;
      color: #717171;
      font-size: 12px;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }

    .arrow-icon {
      width: 10px;
      height: 6px;
      opacity: 0.8;
    }
  }

  .divider {
    width: 1px;
    height: 16px;
    background: rgba(255, 255, 255, 0.3);
  }
}

// 标题栏
.region-picker-header {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #f2f3f5;

  span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
}

// 双列主体
.region-picker-body {
  display: flex;
  height: 60vh;
}

// 左侧列
.region-left-col {
  width: 40%;
  min-width: 120px;
  background: #f7f8fa;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-right: 1px solid #f2f3f5;

  // 州市级账号无右栏时铺满
  &.full-width {
    width: 100%;
    background: #fff;
    border-right: none;
  }

  .region-left-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 12px;
    font-size: 14px;
    color: #333;

    // 有子级的项被展开时（如昆明市被点中）
    &.active {
      background: #fff;
      color: #00bc71;
      font-weight: 500;
    }

    // 叶子节点被选中时（如"全部"被选中）
    &.selected {
      color: #00bc71;
      font-weight: 500;
    }
  }
}

// 右侧列
.region-right-col {
  flex: 1;
  background: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  .region-right-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 16px;
    font-size: 14px;
    color: #333;

    &.active {
      color: #00bc71;
      font-weight: 500;
    }
  }
}
</style>
